<form [formGroup]="contractForm">
  <!-- Fila 1: Duración + Tipo (col-6) -->
  <div class="row">
    <div class="col-6 col-xl-6 mb-3">
      <label for="duration" class="form-label">{{
        "inputs.duration" | translate
        }}</label>
      <ng-select formControlName="duration" [items]="durationOptions"
        [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="false"
        [notFoundText]="'tables.no_results' | translate" (change)="calculateKms()">
        <ng-template ng-label-tmp let-item="item">
          {{ item }} {{ "inputs.month" | translate }}
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          {{ item }} {{ "inputs.month" | translate }}
        </ng-template>
      </ng-select>
    </div>
    <div class="col-6 col-xl-6 mb-3">
      <label for="type" class="form-label">{{
        "inputs.type" | translate
        }}</label>
      <ng-select formControlName="type" [items]="type_"
        [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="false"
        [notFoundText]="'tables.no_results' | translate" (change)="changeType($event)">
        <ng-template ng-label-tmp let-item="item">
          {{ "inputs." + item | translate }}
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          {{ "inputs." + item | translate }}
        </ng-template>
      </ng-select>
    </div>
  </div>

  <!-- Fila 2: Kms anuales + Kms totales (col-6) -->
  <div class="row">
    <div class="col-6 col-xl-6 mb-3">
      <label for="yearly_kms" class="form-label">{{
        "inputs.yearly_kms" | translate
        }}</label>
      <div class="input-group">
        <input type="text" class="form-control" id="yearly_kms" required formControlName="yearly_kms" placeholder="{{
          'inputs.yearly_kms' | translate
        }}" />
      </div>
    </div>
    <div class="col-6 col-xl-6 mb-3">
      <label for="total_kms" class="form-label">{{
        "inputs.total_kms" | translate
        }}</label>
      <div class="input-group">
        <input type="text" class="form-control" id="total_kms" required formControlName="total_kms" placeholder="{{
          'inputs.total_kms' | translate
        }}" />
      </div>
    </div>
  </div>

  <!-- Fila 3: Cuota mensual — 3x col-4 -->
  <div class="row">
    <div class="col-12">
      <label for="monthly_fee_base" class="form-label">{{
        "inputs.monthly_fee" | translate
        }}</label>
    </div>
    <div class="col-4 mb-3">
      <div class="input-group">
        <div class="currencydiv">
          <input type="text" class="form-control" id="monthly_fee_base" required
            formControlName="monthly_fee_base" placeholder="{{
                'inputs.monthly_fee_base' | translate
              }}" />
          <span> +</span>
        </div>
      </div>
      <label for="monthly_fee_tax" class="form-label text08">{{
        "inputs.base" | translate
        }}</label>
    </div>
    <div class="col-4 mb-3">
      <div class="input-group">
        <div class="currencydiv">
          <input type="text" class="form-control" id="monthly_fee_tax" required formControlName="monthly_fee_tax"
            placeholder="{{
                'inputs.monthly_fee_tax' | translate
              }}" />
          <span>=</span>
        </div>
      </div>
      <label for="monthly_fee_tax" class="form-label text08">{{
        "inputs.tax" | translate
        }}</label>
    </div>
    <div class="col-4 mb-3">
      <div class="input-group">
        <div class="currencydiv">
          <input type="text" class="form-control" id="monthly_fee_total" required
            formControlName="monthly_fee_total" placeholder="{{
                'inputs.monthly_fee_total' | translate
              }}" />
          <span>EUR</span>
        </div>
      </div>
      <label for="monthly_fee_tax" class="form-label text08">{{
        "inputs.total" | translate
        }}</label>
    </div>
  </div>

  <!-- Link cambiar configuración -->
  <div *ngIf="showEditConfigButton" class="row mb-2">
    <div class="col-12 d-flex justify-content-end">
      <a class="link-edit-config" (click)="onEditConfigClick()">
        <i class="icon-grid"></i> {{ "forms.buttons.change_configuration" | translate }}
      </a>
    </div>
  </div>

  <div class="row linea"></div>

  <!-- Fila 4: Incluye — checkboxes con notas condicionales -->
  <div class="mb-3">
    <label class="form-label">{{ "inputs.include" | translate }}</label>

    <!-- Seguro -->
    <div class="form-check require-action">
      <input class="form-check-input" type="checkbox" formControlName="include_insurance" />
      <label class="form-check-label">{{ "inputs.insurance" | translate }}</label>
    </div>
    <div class="row mt-2 mb-3" *ngIf="hasCampaign && contractForm.get('include_insurance')?.value">
      <div class="col-8">
        <textarea class="form-control" formControlName="insurance_notes" rows="3" style="resize:none"
          placeholder="{{ 'inputs.insurance_notes' | translate }}"></textarea>
      </div>
      <div class="col-4">
        <div class="currencydiv">
          <input type="number" class="form-control" formControlName="insurance_deductible"
            [attr.disabled]="isBroker ? true : null"
            placeholder="{{ 'inputs.insurance_deductible' | translate }}" min="0" />
          <span> EUR</span>
        </div>
      </div>
    </div>

    <!-- Mantenimiento -->
    <div class="form-check require-action">
      <input class="form-check-input" type="checkbox" formControlName="include_maintenance" />
      <label class="form-check-label">{{ "inputs.maintance" | translate }}</label>
    </div>
    <div class="row mt-2 mb-3" *ngIf="hasCampaign && contractForm.get('include_maintenance')?.value">
      <div class="col-8">
        <textarea class="form-control" formControlName="maintenance_notes" rows="3" style="resize:none"
          placeholder="{{ 'inputs.maintenance_notes' | translate }}"></textarea>
      </div>
    </div>

    <!-- Neumáticos -->
    <div class="form-check require-action">
      <input class="form-check-input" type="checkbox" formControlName="include_tires" />
      <label class="form-check-label">{{ "inputs.tires" | translate }}</label>
    </div>
    <div class="row mt-2 mb-3" *ngIf="hasCampaign && contractForm.get('include_tires')?.value">
      <div class="col-8">
        <textarea class="form-control" formControlName="tires_notes" rows="3" style="resize:none"
          placeholder="{{ 'inputs.tires_notes' | translate }}"></textarea>
      </div>
    </div>

    <!-- Vehículo de sustitución -->
    <div class="form-check require-action">
      <input class="form-check-input" type="checkbox" formControlName="include_replacement_vehicle" />
      <label class="form-check-label">{{ "inputs.replacement_vehicle" | translate }}</label>
    </div>
    <div class="row mt-2 mb-3" *ngIf="hasCampaign && contractForm.get('include_replacement_vehicle')?.value">
      <div class="col-8">
        <textarea class="form-control" formControlName="replacement_vehicle_notes" rows="3" style="resize:none"
          placeholder="{{ 'inputs.replacement_vehicle_notes' | translate }}"></textarea>
      </div>
    </div>
  </div>

  <div class="row linea"></div>

  <!-- Fila 5: Pagos — 2 columnas de 2 (input + checkbox cada uno) -->
  <div class="row">
    <div class="col-6 mb-3">
      <div class="mb-2">
        <label for="initial_payment" class="form-label">{{
          "inputs.initial_payment" | translate
          }}</label>
        <div class="input-group">
          <div class="currencydiv">
            <input type="text" class="form-control" id="initial_payment" required formControlName="initial_payment"
              placeholder="{{
                'inputs.initial_payment' | translate
              }}" />
            <span> EUR</span>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center">
        <div class="form-check require-action">
          <input class="form-check-input" type="checkbox" formControlName="initial_payment_paid">
          <label class="form-check-label" for="initial_payment_paid">
            {{ "inputs.initial_payment_paid" | translate }}
          </label>
        </div>
      </div>
    </div>

    <div class="col-6 mb-3">
      <div class="mb-2">
        <label for="prepayment" class="form-label"> {{"inputs.prepayment" | translate}}</label>
        <div class="input-group">
          <div class="currencydiv">
            <input type="text" class="form-control" id="prepayment" required formControlName="prepayment" placeholder="{{
              'inputs.prepayment' | translate
            }}" />
            <span> EUR</span>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center">
        <div class="form-check require-action">
          <input class="form-check-input" type="checkbox" formControlName="prepayment_paid">
          <label class="form-check-label" for="prepayment_paid">
            {{ "inputs.prepayment_paid" | translate }}
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-6 mb-3">
      <div class="mb-2">
        <label for="transport" class="form-label">{{
          "inputs.transport" | translate
          }}</label>
        <div class="input-group">
          <div class="currencydiv">
            <input type="text" class="form-control" id="transport" required formControlName="transport" placeholder="{{
              'inputs.transport' | translate
            }}" />
            <span> EUR</span>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center">
        <div class="form-check require-action">
          <input class="form-check-input" type="checkbox" formControlName="transport_paid">
          <label class="form-check-label" for="transport_paid">
            {{ "inputs.transport_paid" | translate }}
          </label>
        </div>
      </div>
    </div>

    <div class="col-6 mb-3">
      <div class="mb-2">
        <label for="deposit" class="form-label">{{
          "inputs.deposit" | translate
          }}</label>
        <div class="input-group">
          <div class="currencydiv">
            <input type="text" class="form-control" id="deposit" required formControlName="deposit" placeholder="{{
              'inputs.deposit' | translate
            }}" />
            <span> EUR</span>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center">
        <div class="form-check require-action">
          <input class="form-check-input" type="checkbox" formControlName="deposit_paid">
          <label class="form-check-label" for="deposit_paid">
            {{ "inputs.deposit_paid" | translate }}
          </label>
        </div>
      </div>
    </div>
  </div>
</form>
